import { transformSearch } from "@/api/helper.ts";
import calendarService from "@/features/dashboard/api/services/calendar-service.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";

export const calendarSearchSchema = z.object({
	search: z.string().optional(),
	entity_type: z.string().optional(),
	include: z.string().optional(),
	calendar_id: z.string().optional(),
	branch_id: z.string().optional(),
});

export const calendarsQueryOptions = (search?: z.infer<typeof calendarSearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["calendars", search],
		queryFn: () => calendarService.list(transformSearch(search, ["calendar_id", "entity_type", "branch_id"])),
		...options,
	});
};

export const calendarSelectedDateQueryOption = (selectedDate: string, search?: z.infer<typeof calendarSearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["calendars", selectedDate, search],
		queryFn: () => calendarService.findById(selectedDate),
		...options,
	});
};

export const useCalendarMutation = (calendarId?: string) => {
	return useMutation({
		mutationKey: ["calendars", calendarId],
		mutationFn: calendarService.upsert,
		meta: {
			successMessage: "Calendar updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["calendars"] }),
	});
};

export const useCalendarDeleteMutation = () => {
	return useMutation({
		mutationKey: ["calendars", "delete"],
		mutationFn: calendarService.deleteById,
		meta: {
			successMessage: "Calendar archived successfully",
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["calendars"],
			});
		},
	});
};
